
export default class Point {
    constructor(readonly x: number = 0, readonly y: number = 0) {}
}



// WEBPACK FOOTER //
// ./src/shared/xp/geom/Point.ts